<template>
  <vs-card>
    <vs-tabs v-model="activeTab" position="top" alignment="fixed" class="gurudwara-tabs-instant">
      <vs-tab label="Gurudwara Details">
        <ShowGuideTutorial module="gurudwara-details" />
        <div class="vx-row px-5">
          <div class="vx-col w-full px-8">
            <form method="POST">
              <h3 class="text-xl w-full font-bold my-5">Basic Details</h3>
              <div class="vx-row">
                <!-- Gurudwara Name -->
                <div class="vx-col w-1/2 mb-8">
                  <vs-input class="w-full" v-validate="'required|exclude_special_char'" v-model="form.name"
                    label="Gurudwara Name *" placeholder="Harmandir Sahib" name="Gurudwara Name" id="Gurudwara Name"
                    :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('Gurudwara Name')">{{ errors.first('Gurudwara Name') }}</span>
                </div>

                <!-- Country -->
                <div class="vx-col w-1/6 mb-8">
                  <label class="vs-input--label">Country *</label>
                  <select-2 class="w-full country-input" name="country" placeholder=" Select Country"
                    :value="form.country" @input="(item) => (form.country = item && item.value)" autocomplete
                    :ssr="true" :multiple="false" v-model="form.country" v-validate="'required'"
                    action="common/getCountries" :viewRendered="false" :options="CountryList" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('country')">{{ errors.first('country') }}</span>
                </div>

                <!-- State -->
                <div class="vx-col w-1/6 mb-8">
                  <label class="vs-input--label">State *</label>
                  <select-2 class="w-full" name="State" placeholder="Select State" :value="form.state"
                    v-model="form.state" @input="(item) => (form.state = item && item.value)" :options="StateList"
                    :viewRendered="false" autocomplete :ssr="true" :multiple="false" v-validate="'required'"
                    action="common/getStates" :params="{ country: form.country }" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('State')">{{ errors.first('State') }}</span>
                </div>

                <!-- City -->
                <div class="vx-col w-1/6 mb-8">
                  <label class="vs-input--label">City *</label>
                  <select-2 class="w-full" name="City" placeholder="Select City" :value="form.city" v-model="form.city"
                    @input="(item) => (form.city = item && item.value)" :options="CityList" autocomplete :ssr="true"
                    :viewRendered="false" :multiple="false" v-validate="'required'" action="common/getCities"
                    :params="{ state: form.state, country: form.country }" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
                </div>

                <!-- Website -->
                <div class="vx-col w-1/3 mb-8">
                  <vs-input icon-pack="feather" icon="icon icon-globe" class="w-full"
                    v-validate="'exclude_special_char|url'" v-model="form.website" label="Website"
                    placeholder="www.google.com" name="Website" id="Website" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('Website')">{{ errors.first('Website') }}</span>
                </div>
                <!-- Email -->
                <div class="vx-col w-1/3 mb-8">
                  <vs-input class="w-full" icon-pack="feather" icon="icon icon-mail" v-validate="'email'"
                    v-model="form.email" label="Email" placeholder="abc@gmail.com" name="Email" id="Email"
                    :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                </div>
                <!-- Phone No -->
                <div class="vx-col w-1/3 mb-8">
                  <label class="vs-input--label">Mobile Number</label>
                  <vue-tel-input :key="isUpdate" v-model="form.mobile_number" class="w-full vs-inputx vs-input--input"
                    name="mobile_number" data-vv-as="Mobile Number" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-if="errors['mobile_number']">
                    {{ errors['mobile_number'] }}
                  </span>
                  <span class="text-danger text-sm" v-show="errors.has('mobile_number')">{{
                    errors.first('mobile_number') }}</span>
                </div>

                <div class="vx-col w-1/2 mb-8">
                  <label class="vs-input--label">Best Weather To Visit *</label>
                  <select-2 class="w-full" :name="'best_weather_to_visit'" placeholder="Select Best Weather To Visit"
                    :options="BEST_WEATHR_TO_VISIT_LIST" autocomplete :ssr="true" v-validate="'required'"
                    :multiple="true" :clearable="!!form.best_weather_to_visit.length"
                    :value="form.best_weather_to_visit" data-vv-as="Best Weather To Visit"
                    @input="(item) => (form.best_weather_to_visit = item && item.value)" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has(`best_weather_to_visit`)">{{
                    errors.first(`best_weather_to_visit`) }}</span>
                </div>

                <div class="vx-col w-1/2 mb-8">
                  <label class="vs-input--label">Best Time To Visit *</label>
                  <select-2 class="w-full" :name="'best_time_to_visit'" placeholder="Select Best Time To Visit"
                    :options="BEST_TIME_TO_VISIT_LIST" autocomplete v-validate="'required'" :ssr="true" :multiple="true"
                    :clearable="!!form.best_time_to_visit.length" :value="form.best_time_to_visit"
                    data-vv-as="Best Time To Visit" @input="(item) => (form.best_time_to_visit = item && item.value)"
                    :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has(`best_time_to_visit`)">{{
                    errors.first(`best_time_to_visit`) }}</span>
                </div>

                <!-- Location Link -->
                <div class="vx-col w-1/2 mb-8">
                  <vs-input icon="icon icon-map-pin" icon-pack="feather" class="w-full"
                    v-validate="'required|exclude_special_char|url'" v-model="form.location_link"
                    label="Location Link *" placeholder=" https://goo.gl/maps/2X1tD5XJ1xC2" name="Location Link"
                    id="Location Link" :disabled="!isEditable" />
                  <span class="text-danger text-sm" v-show="errors.has('Location Link')">{{ errors.first('Location Link') }}</span>
                </div>
                <!-- Latitude -->
                <div class="vx-col w-1/4 mb-8">
                  <vs-input class="w-full" v-model="form.latitude" label="Latitude *" placeholder="Enter latitude"
                    name="latitude" :disabled="!isEditable" v-validate="'decimal|min_value:-90|max_value:90'" />
                  <span class="text-danger text-sm" v-show="errors.has('latitude')">{{ errors.first('latitude')
                  }}</span>
                </div>

                <!-- Longitude -->
                <div class="vx-col w-1/4 mb-8">
                  <vs-input class="w-full" v-model="form.longitude" label="Longitude *" placeholder="Enter longitude"
                    name="longitude" :disabled="!isEditable" v-validate="'decimal|min_value:-180|max_value:180'" />
                  <span class="text-danger text-sm" v-show="errors.has('longitude')">{{ errors.first('longitude')
                  }}</span>
                </div>

                <div class="vx-col w-full mt-4">
                  <vs-textarea cols="3" rows="5" icon-pack="feather" class="w-full mb-0"
                    v-validate="'required|exclude_special_char'" v-model="form.address" label="Address *" name="Address"
                    id="Address" style="border: 2px solid var(--divider)" :disabled="!isEditable">
                  </vs-textarea>
                  <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
                </div>

                <vs-divider></vs-divider>

                <!-- Gurudwara Images -->
                <h3 class="text-xl w-full font-bold my-5 ml-4">Gurudwara Images</h3>
                <div class="vx-col w-full" v-if="isEditable">
                  <label class="vs-input--label block"> Images * </label>
                  <p class="text-base">Select up to 20 images, each under 1 MB, in JPG, PNG, or JPEG format</p>
                  <input :key="fileKey" type="file" class="rounded w-full text-lg file-upload" id="Gurudwara image"
                    ref="files" accept=".jpg, .png , .jpeg" @change="handleFileUpload" multiple />
                  <input type="hidden" name="Gurudwara image" v-model="form.gurudwara_image"
                    v-validate="validationRules()" data-vv-as="Image" />
                  <span class="text-danger text-sm" v-show="errors.has('Gurudwara image')">{{ errors.first('Gurudwara image') }}</span>
                </div>
                <div class="vx-col w-1/2 mb-8"></div>
                <div class="vx-col w-full mb-20">
                  <div class="mt-5 flex items-center flex-wrap gap-5">
                    <div v-for="(image, index) in form.exist_gurudwara_image" :key="index" class="relative group"
                      style="width: 20rem !important; height: 20rem !important">
                      <div class="overflow-hidden rounded-lg h-full">
                        <img :src="image" alt="Image Preview"
                          style="width: 20rem !important; height: 20rem !important" />
                        <div class="absolute top-0 right-0" v-if="isEditable">
                          <vx-tooltip :text="`Remove`" class="cursor-pointer">
                            <div style="background-color: var(--neutral); color: var(--neutral-invert);"
                              class="text-xl w-12 h-12 flex justify-center items-center rounded-lg m-2"
                              @click="removeFile(image, 'edit')">&#x2715;</div>
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                    <div v-for="(image, index) in preview_images" :key="index" class="relative group"
                      style="width: 20rem !important; height: 20rem !important">
                      <div class="overflow-hidden rounded-lg h-full">
                        <img :src="image.src" alt="Image Preview"
                          style="width: 20rem !important; height: 20rem !important" />
                        <div class="absolute top-0 right-0">
                          <vx-tooltip :text="`Remove`" class="cursor-pointer">
                            <div style="background-color: var(--neutral); color: var(--neutral-invert);"
                              class="text-xl w-12 h-12 flex justify-center items-center rounded-lg m-2"
                              @click="removeFile(index, 'preview')">&#x2715;</div>
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <vs-divider></vs-divider>

                <!-- Gurudwara Videos -->
                <h3 class="text-xl w-full font-bold my-5 ml-4">Gurudwara Videos</h3>
                <div class="vx-col w-full" v-if="isEditable">
                  <label class="vs-input--label block"> Videos </label>
                  <p class="text-base">Select up to 20 videos, each under 60 seconds, in any format</p>
                  <input :key="'video-' + fileKey" type="file" class="rounded w-full text-lg file-upload"
                    id="Gurudwara video" ref="videoFiles" accept="video/*" @change="handleVideoUpload" multiple />
                </div>
                <div class="vx-col w-1/2 mb-8"></div>
                <div class="vx-col w-full mb-20">
                  <div class="mt-5 flex items-center flex-wrap gap-5">
                    <div v-for="(video, index) in form.exist_gurudwara_video" :key="'exist-video-' + index"
                      class="relative group" style="width: 20rem !important; height: 20rem !important">
                      <div class="overflow-hidden rounded-lg h-full">
                        <video :src="video" class="w-full h-full object-cover" controls></video>
                        <div class="absolute top-0 right-0" v-if="isEditable">
                          <vx-tooltip :text="`Remove`" class="cursor-pointer">
                            <div style="background-color: var(--neutral); color: var(--neutral-invert);"
                              class="text-xl w-12 h-12 flex justify-center items-center rounded-lg m-2"
                              @click="removeVideo(video, 'edit')">&#x2715;</div>
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                    <div v-for="(video, index) in preview_videos" :key="'preview-video-' + index" class="relative group"
                      style="width: 20rem !important; height: 20rem !important">
                      <div class="overflow-hidden rounded-lg h-full">
                        <video :src="video.src" class="w-full h-full object-cover" controls></video>
                        <div class="absolute top-0 right-0">
                          <vx-tooltip :text="`Remove`" class="cursor-pointer">
                            <div style="background-color: var(--neutral); color: var(--neutral-invert);"
                              class="text-xl w-12 h-12 flex justify-center items-center rounded-lg m-2"
                              @click="removeVideo(index, 'preview')">&#x2715;</div>
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <vs-divider></vs-divider>
                <!-- Gurudwara History -->
                <h3 class="text-xl w-full font-bold my-5 ml-4">Gurudwara History*</h3>
                <div class="vx-col w-full mt-4">
                  <vs-textarea rows="12" cols="5" icon-pack="feather" class="w-full mb-0"
                    v-validate="'required|exclude_special_char'" v-model="form.history" label=""
                    name="Gurudwara History" id="Gurudwara History" style="border: 2px solid var(--divider)"
                    :disabled="!isEditable">
                  </vs-textarea>
                  <span class="text-danger text-sm" v-show="errors.has('Gurudwara History')">{{ errors.first('Gurudwara History') }}</span>
                </div>
                <vs-divider></vs-divider>
                <div class="vx-col w-full my-5 mb-8">
                  <h3 class="text-xl font-bold">Amenities Details</h3>
                  <div class="amenities-container vx-row mt-4">
                    <div class="vx-col w-2/12 mb-8">
                      <label class="vs-input--label">Free Wifi</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.free_wifi" :disabled="!isEditable">
                      </vs-switch>
                    </div>
                    <div class="vx-col w-2/12 mb-8">
                      <label class="vs-input--label">Parking</label>
                      <vs-switch color="success" class="ml-1 mt-2" v-model="form.parking" :disabled="!isEditable">
                      </vs-switch>
                    </div>
                  </div>
                </div>
                <vs-divider></vs-divider>

                <div class="vx-col w-full mt-5 mb-8 ml-4">
                  <div class="vx-col w-1/2 flex items-center justify-between mt-2">
                    <h3 class="vx-row text-xl font-bold my-5">Opening Hours</h3>
                    <div class="flex items-center justify-center gap-x-4">
                      <vs-switch v-model="form.is24hOpen" @change="handle24hToggle" color="success" class="ml-1"
                        :disabled="!isEditable"></vs-switch>
                      <span class="text-base">Open All Day (24/7)</span>
                    </div>
                  </div>
                  <div class="vx-row mt-8 mb-8">
                    <label class="flex items-center w-64 font-semibold">Day</label>
                    <div class="vx-col flex items-center w-64 text-lg font-semibold">Open Time</div>
                    <div class="vx-col flex items-center w-64 text-lg font-semibold">Close Time</div>
                    <vx-tooltip :text="`Copy to All Days`">
                      <vs-button v-if="checkModifiedDay && !form.is24hOpen" @click="copyToAllDays" color="primary"
                        size="large" icon-pack="feather" icon="icon-copy">Copy To All Days</vs-button>
                    </vx-tooltip>
                  </div>

                  <div v-for="(day, index) in WEEK_DAYS" :key="index" class="vx-row mb-8">
                    <!-- Format UTC date to local time -->
                    <label class="flex items-center w-64 text-lg font-normal" :for="day">{{ day }}</label>
                    <div class="vx-col w-64">
                      <flat-pickr :config="configdateTimePicker"
                        v-model="form.opening_hours.find((d) => d.day === day).open_time"
                        :name="`opening_hours_open_time_${day}`" v-validate="'required'"
                        :data-vv-as="`${day} Open Time`" placeholder="Open Time"
                        class="form-control dropdown-color hours-dropdown mt-1"
                        @on-change="(selectedDates) => validateTime(day, selectedDates[0], 'open_time')"
                        :disabled="form.is24hOpen || !isEditable" />

                      <span class="text-danger text-sm" v-show="errors.has(`opening_hours_open_time_${day}`)">{{
                        errors.first(`opening_hours_open_time_${day}`) }}</span>
                    </div>
                    <div class="vx-col w-64">
                      <flat-pickr :config="configdateTimePicker"
                        v-model="form.opening_hours.find((d) => d.day === day).close_time"
                        :name="`opening_hours_close_time_${day}`" v-validate="'required'"
                        :data-vv-as="`${day} Close Time`" placeholder="Close Time"
                        class="form-control dropdown-color hours-dropdown mt-1"
                        @on-change="(selectedDates) => validateTime(day, selectedDates[0], 'close_time')"
                        :disabled="form.is24hOpen || !isEditable" />

                      <span class="text-danger text-sm" v-show="errors.has(`opening_hours_close_time_${day}`)">{{
                        errors.first(`opening_hours_close_time_${day}`) }}</span>
                    </div>

                    <span class="text-danger text-sm" v-if="errors[day]">
                      {{ errors[day] }}
                    </span>
                  </div>
                </div>
              </div>

              <vs-divider></vs-divider>

              <!-- Social Media Links Section -->
              <div class="vx-col w-full mb-4">
                <h3 class="text-xl font-bold my-10">Social Media Links</h3>
                <div class="vx-row mt-4">
                  <!-- Facebook -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" data-vv-validate-on="blur"
                      v-model="form.social_media.facebook" label="Facebook"
                      placeholder="https://www.facebook.com/YourPage" name="Facebook" id="Facebook"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('Facebook')">{{ errors.first('Facebook')
                    }}</span>
                  </div>
                  <!-- Instagram -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" data-vv-validate-on="blur"
                      v-model="form.social_media.instagram" label="Instagram"
                      placeholder="https://www.instagram.com/YourProfile" name="Instagram" id="Instagram"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('Instagram')">{{ errors.first('Instagram')
                    }}</span>
                  </div>
                  <!-- Twitter -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" data-vv-validate-on="blur"
                      v-model="form.social_media.twitter" label="Twitter"
                      placeholder="https://www.twitter.com/YourProfile" name="Twitter" id="Twitter"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('Twitter')">{{ errors.first('Twitter')
                    }}</span>
                  </div>
                  <!-- Snapchat -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" data-vv-validate-on="blur"
                      v-model="form.social_media.snapchat" label="Snapchat"
                      placeholder="https://www.snapchat.com/YourProfile" name="Snapchat" id="Snapchat"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('Snapchat')">{{ errors.first('Snapchat')
                    }}</span>
                  </div>
                  <!-- TikTok -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" data-vv-validate-on="blur"
                      v-model="form.social_media.tiktok" label="TikTok"
                      placeholder="https://www.tiktok.com/@YourProfile" name="TikTok" id="TikTok"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('TikTok')">{{ errors.first('TikTok') }}</span>
                  </div>
                  <!-- LinkedIn -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" data-vv-validate-on="blur"
                      v-model="form.social_media.linkedin" label="LinkedIn"
                      placeholder="https://www.linkedin.com/in/YourProfile" name="LinkedIn" id="LinkedIn"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('LinkedIn')">{{ errors.first('LinkedIn')
                    }}</span>
                  </div>
                  <!-- YouTube -->
                  <div class="vx-col w-1/3 mb-8">
                    <vs-input class="w-full" v-validate="'url'" data-vv-validate-on="blur"
                      v-model="form.social_media.youtube" label="YouTube"
                      placeholder="https://www.youtube.com/c/YourChannel" name="YouTube" id="YouTube"
                      :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has('YouTube')">{{ errors.first('YouTube')
                    }}</span>
                  </div>
                </div>
              </div>
              <vs-divider></vs-divider>
              <!-- Other Links Fields Section -->
              <div class="w-full mb-4">
                <div class="flex justify-between my-5">
                  <div class="flex items-center">
                    <h3 class="text-xl font-bold">Other Links</h3>
                  </div>
                  <vs-button @click="addOtherLink()" class="mb-4 color" size="default" v-if="isEditable"> Add Other
                    Name</vs-button>
                </div>
                <!-- <div class="flex justify-between items-center mb-8">
                  <h4 class="text-lg font-semibold">Other Links</h4>
                  <vx-tooltip :text="`Add Other Links`">
                    <vs-button color="success" type="gradient" icon-pack="feather" icon="icon-plus" />
                  </vx-tooltip>
                </div> -->
                <div v-for="(otherLink, index) in form.custom_link" :key="index"
                  class="other-link-entry w-full flex flex-wrap mb-8">
                  <div class="vx-col w-full md:w-1/2 px-2 mb-8">
                    <vs-input v-model="otherLink.title" label="Title *" :name="'other_link_title_' + index"
                      v-validate="'required|exclude_special_char'" data-vv-as="Title" placeholder="Enter title"
                      class="w-full" :disabled="!isEditable" />
                    <span class="text-danger text-sm" v-show="errors.has(`other_link_title_${index}`)">{{
                      errors.first(`other_link_title_${index}`) }}</span>
                  </div>
                  <div class="vx-col w-full md:w-1/2 px-2 mb-8">
                    <div class="flex items-center">
                      <vs-input v-model="otherLink.link" label="Link *" :name="'other_link_link_' + index"
                        v-validate="'required|exclude_special_char'" data-vv-as="Other Link" placeholder="Enter link"
                        class="w-full" :disabled="!isEditable" />
                      <vx-tooltip :text="`Remove Other Link`" class="ml-2 mt-6">
                        <vs-button @click="removeOtherLink(index)" color="danger" type="gradient" icon-pack="feather"
                          icon="icon-trash-2" />
                      </vx-tooltip>
                    </div>
                    <span class="text-danger text-sm" v-show="errors.has(`other_link_link_${index}`)">{{
                      errors.first(`other_link_link_${index}`) }}</span>
                  </div>
                </div>
              </div>

              <vs-divider></vs-divider>
              <div class="vx-col w-full mb-8">
                <!-- Add Other Name -->
                <div class="flex justify-between my-5">
                  <div class="flex items-center">
                    <h3 class="text-xl font-bold">Other Names</h3>
                  </div>
                  <vs-button @click="addData('other_name')" class="mb-4 color" size="default" v-if="isEditable"> Add
                    Other Name</vs-button>
                </div>
                <div class="other_name-container vx-row">
                  <div v-for="(record_value, index) in form.other_name" :key="index"
                    class="other-name-entry flex border-sky-500 border vx-col w-1/3">
                    <!-- Other Name -->
                    <div class="w-full mb-8">
                      <vs-input icon-pack="feather" type="text" v-validate="'required|exclude_special_char'"
                        data-vv-as="Other Name" v-model="form.other_name[index]" label="Other Name"
                        placeholder=" Golden Temple" :name="'other_name_' + index" class="w-full"
                        :disabled="!isEditable" />
                      <span class="text-danger text-sm" v-show="errors.has(`other_name_${index}`)">{{
                        errors.first(`other_name_${index}`) }}</span>
                    </div>
                    <!-- Remove Other Name -->
                    <div class="w-1/12 flex items-center ml-1" v-if="isEditable">
                      <vx-tooltip :text="`Remove`">
                        <vs-button @click="removeData('other_name', index)" color="danger" type="gradient"
                          icon-pack="feather" icon="icon-trash-2" />
                      </vx-tooltip>
                    </div>
                  </div>
                </div>
              </div>

              <vs-divider></vs-divider>
              <!-- Youtube Handle Name -->
              <div class="vx-col w-full mb-8">
                <div class="flex justify-between my-5">
                  <div class="flex items-center">
                    <h3 class="text-xl font-bold">Youtube Handle Names</h3>
                  </div>
                  <vs-button @click="addData('youtube_handle_name')" class="mb-4 color" size="default"
                    v-if="isEditable">Add Handle Name</vs-button>
                </div>

                <div class="youtube_handle_name-container vx-row">
                  <div v-for="(record_value, index) in form.youtube_handle_name" :key="index"
                    class="other-name-entry flex border-sky-500 border vx-col w-1/3">
                    <div class="w-full mb-8">
                      <vs-input icon-pack="feather" type="text" v-validate="'required|exclude_special_char'"
                        data-vv-as="Youtube Handle Name" v-model="form.youtube_handle_name[index]"
                        label="Youtube Handle Name" placeholder="HarmandirSahibOfficial"
                        :name="'youtube_handle_name_' + index" class="w-full" :disabled="!isEditable" />
                      <span class="text-danger text-sm" v-show="errors.has(`youtube_handle_name_${index}`)">{{
                        errors.first(`youtube_handle_name_${index}`) }}</span>
                    </div>
                    <div class="w-1/12 flex items-center ml-1" v-if="isEditable">
                      <vx-tooltip :text="`Remove`">
                        <vs-button @click="removeData('youtube_handle_name', index)" color="danger" type="gradient"
                          icon-pack="feather" icon="icon-trash-2" />
                      </vx-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <vs-divider></vs-divider>

              <!-- Save & Reset Button -->
              <div class="vx-row pt-5 px-5 text-center">
                <div class="vx-col w-full">
                  <div class="items-center">
                    <vs-button class="mr-2 w-64 vs-con-loading__container color" color="success" id="create-gurudwara"
                      @click="save_changes" v-if="isEditable"> Save & Next </vs-button>
                    <!-- <vs-button class="mr-2 vs-con-loading__container color" id="create-gurudwara" @click="nextTab" > Next</vs-button> -->
                    <!-- <vs-button color="danger" class="text-left" @click="navigateToGurudwaraList">Cancel</vs-button> -->
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </vs-tab>
      <!-- v-if="checkPermissionSlug(['gurudwara_update_create', 'gurudwara_update_view'])" -->
      <vs-tab label="Update" :disabled="disabledTab">
        <UpdateList />
      </vs-tab>
      <vs-tab label="Sarai" :disabled="disabledTab" v-if="checkPermissionSlug(['stay_edit', 'stay_view'])">
        <SaraiManagement :gurudwara-id="$route.params.id" :is-editable="isStayEditable" />
      </vs-tab>
      <vs-tab label="Services" :disabled="disabledTab"
        v-if="showServicesTab">
        <ShowGuideTutorial module="gurudwara-service" />
        <ServiceList />
      </vs-tab>
      <vs-tab label="Donation" :disabled="disabledTab"
        v-if="checkPermissionSlug(['gurudwara_donation_create', 'gurudwara_donation_edit', 'gurudwara_donation_view', 'gurudwara_donation_list'])">
        <DonationList />
      </vs-tab>
      <vs-tab label="Ragi Schedule" :disabled="disabledTab"
        v-if="checkPermissionSlug(['gurudwara_ragi_create', 'gurudwara_ragi_edit', 'gurudwara_ragi_view'])">
        <ShowGuideTutorial module="ragi-schedule" />
        <RagiList />
      </vs-tab>
      <vs-tab label="Katha Schedule" :disabled="disabledTab"
        v-if="checkPermissionSlug(['gurudwara_katha_create', 'gurudwara_katha_edit', 'gurudwara_katha_view'])">
        <ShowGuideTutorial module="katha-schedule" />
        <KathaList />
      </vs-tab>
      <vs-tab label="Daily Routines" :disabled="disabledTab"
        v-if="checkPermissionSlug(['daily_routine_view', 'daily_routine_edit'])">
        <ShowGuideTutorial module="daily-routines" />
        <DailyRoutineList />
      </vs-tab>
      <vs-tab label="Contact Us" :disabled="disabledTab"
        v-if="checkPermissionSlug(['gurudwara_contact_create', 'gurudwara_contact_edit', 'gurudwara_contact_view'])">
        <ShowGuideTutorial module="contact-us" />
        <ContactList />
      </vs-tab>
      <vs-tab label="Thumbnail Manage" :disabled="disabledTab"
        v-if="checkRolesByIds(['admin', 'support_administrator'])">
        <ShowGuideTutorial module="gurudwara-thumbnail" />
        <GraphichManage />
      </vs-tab>
      <vs-tab label="FAQs" :disabled="disabledTab" v-if="checkPermissionSlug(['faq_create', 'faq_edit', 'faq_view'])">
        <ShowGuideTutorial module="faqs" />
        <FaqList />
      </vs-tab>
      <vs-tab label="Tabs" :disabled="disabledTab" v-if="checkRolesByIds(['admin', 'support_administrator'])">
        <TabManage />
      </vs-tab>
    </vs-tabs>
    <vs-popup title="Image Editor" name="Image" :active.sync="IsOpenImageCrop"
      class="image-cropper gurudwara-edit-cropper" style="z-index: 55000; overflow: hidden">
      <div class="text-center flex justify-center modal-content-body w-full h-full overflow-y">
        <!-- modal content -->
        <div class="modal__content w-full h-full">
          <!-- modal body -->
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div v-for="(cropImage, index) in this.crop_image" :key="index" class="cropper-container">
                <div class="w-full h-full max-h-450 py-5">
                  <cropper ref="cropper" :name="'Image' + index" class="cropper-image" :src="cropImage.src"
                    :stencil-props="{ aspectRatio: 12 / 12 }" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- modal content ends -->
      </div>
      <div class="button-wrapper modal-footer bottom-20 text-center p-0" style="border-top: 1px solid #dddddd">
        <vs-button type="" @click="cropImage()" class="text-white bg-black mt-5 mb-5 hover:shadow-lg">Save &
          Upload</vs-button>
      </div>
    </vs-popup>
  </vs-card>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState, mapGetters } from 'vuex'
import FaqList from './faq/list'
import DailyRoutineList from './dailyRoutine/list'
import ContactList from './contact/list'
import KathaList from './katha/list'
import RagiList from './ragi/list'
import UpdateList from './update'
import DonationList from './donation/list'
import ServiceList from './service'
import GraphichManage from './graphics/action'
import TabManage from './tab/action'
import ShowGuideTutorial from './show-guide-tutorial'
import SaraiManagement from './sarai/SaraiManagement.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { dateMixins } from '@/mixins/dateMixins.js'
import moment from 'moment'
import { GURUDWARA_MAX_IMAGES_COUNT, GURUDWARA_MAX_VIDEOS_COUNT, MAX_IMAGE_SIZE, MAX_VIDEO_DURATION } from '../../utils/predefineTypes.js/constant'

export default {
  /** Page Name */
  name: 'AddUpdate',

  mixins: [dateMixins],

  /** components */
  components: {
    Select2,
    Cropper,
    FaqList,
    DailyRoutineList,
    ContactList,
    KathaList,
    RagiList,
    DonationList,
    GraphichManage,
    TabManage,
    ServiceList,
    flatPickr,
    ShowGuideTutorial,
    UpdateList,
    SaraiManagement
  },

  /** data */
  data() {
    return {
      fileKey: 0,
      lastModifiedDay: null,
      isUpdate: false,
      disabledTab: true,
      activeTab: 0,
      countryID: null,
      stateID: null,
      cityID: null,
      StateList: [],
      CountryList: [],
      CityList: [],
      BEST_WEATHR_TO_VISIT_LIST: [],
      BEST_TIME_TO_VISIT_LIST: [],
      breadcrumb: [],
      form: {
        latitude: null, // Add this field
        longitude: null, // Add this field
        custom_link: [],
        name: null,
        location_link: null,
        country: null,
        address: null,
        history: null,
        website: null,
        mobile_number: '',
        email: null,
        state: null,
        city: null,
        other_name: [],
        youtube_handle_name: [],
        gurudwara_image: [],
        gurudwara_video: [],
        exist_gurudwara_image: [],
        exist_gurudwara_video: [],
        best_weather_to_visit: [],
        best_time_to_visit: [],
        free_wifi: false,
        parking: false,
        is24hOpen: false,
        opening_hours: [
          { day: 'Sunday', open_time: null, close_time: null },
          { day: 'Monday', open_time: '', close_time: '' },
          { day: 'Tuesday', open_time: '', close_time: '' },
          { day: 'Wednesday', open_time: '', close_time: '' },
          { day: 'Thursday', open_time: '', close_time: '' },
          { day: 'Friday', open_time: '', close_time: '' },
          { day: 'Saturday', open_time: '', close_time: '' }
        ],
        social_media: {
          facebook: null,
          instagram: null,
          twitter: null,
          snapchat: null,
          tiktok: null,
          linkedin: null,
          youtube: null
        }
      },
      sarai_form: {
        details: [],
        offer_sarai_stay: true
      },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'h:i K'
        // time_24hr: true
      },

      WEEK_DAYS: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      preview_images: [],
      preview_videos: [],
      crop_image: [],
      IsOpenImageCrop: false
    }
  },

  /** computed */
  computed: {
    ...mapState('gurudwara', ['createLoading']),
    ...mapState('auth', ['roles', 'userInfo']),
    ...mapGetters('auth', ['checkPermissionSlug', 'checkRolesByIds']),
    isEditable() {
      return this.checkPermissionSlug('gurudwara_edit')
    },

    isStayEditable() {
      return this.checkPermissionSlug('stay_edit')
    },

    showServicesTab() {
      const servicePermissions = [
        'available_service_list',
        'available_service_create',
        'available_service_edit',
        'available_service_view',
        'gurudwara_service_view',
        'gurudwara_service_create',
        'gurudwara_service_edit',
        'gurudwara_service_delete',
        'gurudwara_service_booking_view',
        'gurudwara_service_booking_create',
        'gurudwara_service_booking_edit',
        'service_list',
        'service_view',
        'service_edit',
        'service_create'
      ]
      if (this.checkPermissionSlug(servicePermissions)) return true
      return this.checkRolesByIds([
        'admin',
        'support_administrator',
        'gurudwara-admin',
        'gurudwara_admin',
        'committee-admin',
        'committee_admin'
      ])
    },

    validateForm() {
      return !this.errors.any()
    },
    openingHourError() {
      const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      return Object.keys(this.errors).some((key) => weekdays.includes(key))
    },
    checkModifiedDay() {
      const modifiedDayData = this.form.opening_hours.find((day) => day.day === this.lastModifiedDay)
      return modifiedDayData && modifiedDayData.open_time && modifiedDayData.close_time
    }
  },

  /** created */
  created() {
    this.disabledTab = this.$route.params.id ? undefined : true
    // Check if we should activate a specific tab from query parameter
    if (this.$route.query.tab === 'sarai') {
      // Sarai Details is the 3rd tab (index 2: 0=Gurudwara Details, 1=Update, 2=Sarai Details)
      this.activeTab = 2
    }
    this.fetchData()
  },

  /** methods */
  methods: {
    handle24hToggle() {
      this.form.opening_hours.forEach((day) => {
        day.open_time = null
        day.close_time = null
      })
      if (this.form.is24hOpen) {
        this.form.opening_hours.forEach((day) => {
          this.$delete(this.errors, day.day) // Remove error if valid
        })
      }
    },
    copyToAllDays() {
      const modifiedDayData = this.form.opening_hours.find((day) => day.day === this.lastModifiedDay)
      if (modifiedDayData) {
        this.form.opening_hours.forEach((day) => {
          day.open_time = modifiedDayData.open_time
          day.close_time = modifiedDayData.close_time
        })
      }
    },

    addOtherLink() {
      // Ensure that custom_fields is initialized before pushing into it
      // if (!this.custom_link) {
      //   this.$set(this.sarai_form.details[saraiIndex], 'custom_fields', [])
      // }
      this.form.custom_link.push({ title: '', link: '' })
    },
    removeOtherLink(index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          this.form.custom_link.splice(index, 1)
        },
        acceptText: 'Delete'
      })
    },
    addCustomField(saraiIndex) {
      // Ensure that custom_fields is initialized before pushing into it
      if (!this.sarai_form.details[saraiIndex].custom_fields) {
        this.$set(this.sarai_form.details[saraiIndex], 'custom_fields', [])
      }
      this.sarai_form.details[saraiIndex].custom_fields.push({ label: '', value: '' })
    },
    removeCustomField(saraiIndex, customIndex) {
      this.sarai_form.details[saraiIndex].custom_fields.splice(customIndex, 1)
    },
    handlePhoneNumberChange(number, phoneObj) {
      this.form.mobile_number = number
    },
    validateTime(day, date, type) {
      const dayData = this.form.opening_hours.find((d) => d.day === day)

      // Ensure dayData exists and there is an open_time or close_time to validate against
      if (!dayData || (!dayData.open_time && !dayData.close_time)) {
        return
      }
      let openTime, closeTime
      if (type === 'open_time') {
        openTime = moment(date, 'hh:mm A')
          .set({ year: 1970, month: 0, date: 1 }) // Setting to January 1, 1970
          .utcOffset(moment().utcOffset()) // Adjust for local timezone
          .utc() // Convert to UTC
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        closeTime = moment(dayData.close_time, 'hh:mm A') // Use 'hh:mm A' for 12-hour format
          .set({ year: 1970, month: 0, date: 1 })
          .utcOffset(moment().utcOffset())
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
      } else if (type === 'close_time') {
        openTime = moment(dayData.open_time, 'hh:mm A') // Use 'hh:mm A' for 12-hour format
          .set({ year: 1970, month: 0, date: 1 })
          .utcOffset(moment().utcOffset())
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        closeTime = moment(date, 'hh:mm A')
          .set({ year: 1970, month: 0, date: 1 }) // Setting to January 1, 1970
          .utcOffset(moment().utcOffset()) // Adjust for local timezone
          .utc() // Convert to UTC
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
      }

      // Validate that closeTime is greater than openTime
      if (closeTime && openTime && closeTime <= openTime) {
        this.$set(this.errors, day, `${dayData.day} close time must be greater than ${dayData.day} open time`)
      } else {
        this.$delete(this.errors, day) // Remove error if valid
      }

      // Show the "Copy to All Days" button
      this.lastModifiedDay = day // Track the modified day
    },
    async fetchData() {
      if (this.$route.params.id) {
        await this.$store.dispatch('gurudwara/show', this.$route.params.id).then(async (res) => {
          const data = res.data.data

          /** breadcrumb implement  */
          this.breadcrumb = [
            { title: 'Dashboard', url: '/dashboard' },
            { title: 'Gurudwara', url: '/gurudwara/list' },
            { title: `Edit ${data.name}`, active: true }
          ]

          this.isUpdate = true
          this.form.country = data.country._id
          this.form.state = data.state._id
          this.form.city = data.city._id

          // this.form.country = this.countryID = data.country._id
          this.cityID = data.city._id

          /* form variable */
          this.form.name = data.name
          this.form.history = data.history
          this.form.address = data.address
          this.form.email = data.email || ''
          this.form.website = data.website
          this.form.mobile_number = data.mobile_number || ''
          this.form.location_link = data.location_link
          this.form.custom_link = data.custom_link || []
          this.form.social_media = {
            facebook: null,
            instagram: null,
            twitter: null,
            snapchat: null,
            tiktok: null,
            linkedin: null,
            youtube: null,
            ...data.social_media // Overwrite with existing data from API
          }
          this.form.free_wifi = data.free_wifi ? data.free_wifi : false
          this.form.parking = data.parking ? data.parking : false
          this.form.best_weather_to_visit = data.best_weather_to_visit ? data.best_weather_to_visit : []
          this.form.best_time_to_visit = data.best_time_to_visit ? data.best_time_to_visit : []
          this.form.is24hOpen = data.is24hOpen ? data.is24hOpen : false
          this.form.latitude = data.location ? data.location.coordinates[1] : null
          this.form.longitude = data.location ? data.location.coordinates[0] : null
          if (data.opening_hours) {
            data.opening_hours.map((v) => {
              const result = {
                open_time: this.formatUTCTime(v.open_time),
                close_time: this.formatUTCTime(v.close_time),
                day: v.day
              }
              const getIndex = this.form.opening_hours.findIndex((v) => v.day == result.day)
              this.form.opening_hours[getIndex] = result
            })
          }
          this.form.other_name = data.other_name
          this.form.youtube_handle_name = data.youtube_handle_name
          this.form.exist_gurudwara_image = data.gurudwara_image
          this.form.exist_gurudwara_video = data.gurudwara_video || []

          const companyResult = await this.getCountries({ page: 1, limit: 300000, type: 'dropdown', country_id: data.country._id })
          this.CountryList = companyResult.data

          if (data.country._id) {
            const stateResult = await this.getStates({ country: data.country._id, page: 1, limit: 300000, type: 'dropdown', state_id: data.state._id })
            this.StateList = stateResult.data
            this.stateID = this.form.state = data.state._id
          }

          if (data.state._id) {
            const cityResult = await this.getCities({ state: data.state._id, country: data.country._id, page: 1, limit: 300000, type: 'dropdown', city_id: data.city._id })
            this.CityList = cityResult.data
            this.cityID = this.form.city = data.city._id
          }
        })

        await this.$store.dispatch('gurudwara/saraiList', this.$route.params.id).then(async (res) => {
          const data = res.data.data
          if (data && data.details) {
            this.sarai_form.offer_sarai_stay = !res.data.offer_sarai_stay
            this.sarai_form.details = data.details.map((v) => {
              // Remove _id from the main object
              delete v._id

              // Check if custom_fields is an array and has elements, then delete _id from each field
              if (Array.isArray(v.custom_fields)) {
                v.custom_fields.forEach((field) => delete field._id)
              }

              return v
            })
          }
        })
      } else {
        const companyResult = await this.getCountries({ page: 1, limit: 300000, type: 'dropdown' })
        this.CountryList = companyResult.data

        this.form.best_weather_to_visit = ['All Weather']
        this.form.best_time_to_visit = ['All Day']
      }

      // if (this.form.other_name < 1) {
      //   this.addData('other_name')
      // }
      if (this.sarai_form.details < 1) {
        this.addData('sarai')
      }
      // if (this.form.youtube_handle_name < 1) {
      //   this.addData('youtube_handle_name')
      // }

      const { best_time_to_visit, best_weather_to_visit } = await this.getPreDefinedValues()
      this.BEST_TIME_TO_VISIT_LIST = best_time_to_visit.map((value) => {
        return {
          value,
          label: value
        }
      })
      this.BEST_WEATHR_TO_VISIT_LIST = best_weather_to_visit.map((value) => {
        return {
          value,
          label: value
        }
      })

      this.disabledTab = this.$route.params.id ? undefined : true
    },

    ...mapActions('gurudwara', {
      create: 'create',
      update: 'update',
      updateSarai: 'updateSarai'
    }),
    ...mapActions('common', {
      getCountries: 'getCountries',
      getStates: 'getStates',
      getCities: 'getCities',
      getPreDefinedValues: 'getPreDefinedValues'
    }),

    validationRules() {
      if (this.$route.params.id && !this.form.exist_gurudwara_image.length) {
        return 'required'
      }
      if (this.$route.path == '/gurudwara/add') {
        return 'required'
      }
    },

    async nextTab() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      this.activeTab = 1
    },
    convertTo24Hour(timeStr) {
      const [time, modifier] = timeStr.split(' ')
      let [hours, minutes] = time.split(':').map(Number)

      if (modifier.toLowerCase() === 'pm' && hours !== 12) {
        hours += 12
      }
      if (modifier.toLowerCase() === 'am' && hours === 12) {
        hours = 0
      }

      const hoursStr = hours.toString().padStart(2, '0')
      const minutesStr = minutes.toString().padStart(2, '0')

      return `${hoursStr}:${minutesStr}:00`
    },

    async save_changes() {
      if (!(await this.$validator.validate()) || this.openingHourError) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (this.form.gurudwara_image.length + this.form.exist_gurudwara_image.length > GURUDWARA_MAX_IMAGES_COUNT) {
        this.$vs.notify({
          title: 'Error',
          text: `A maximum of ${GURUDWARA_MAX_IMAGES_COUNT} images are allowed. Please remove extra images.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (this.form.gurudwara_video.length + this.form.exist_gurudwara_video.length > GURUDWARA_MAX_VIDEOS_COUNT) {
        this.$vs.notify({
          title: 'Error',
          text: `A maximum of ${GURUDWARA_MAX_VIDEOS_COUNT} videos are allowed. Please remove extra videos.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        const data = new FormData()
        for (const key in this.form) {
          if ((key === 'opening_hours' && this.form.is24hOpen) || key === 'latitude' || key === 'longitude') continue

          if (typeof this.form[key] === 'object') {
            if (key === 'opening_hours') {
              this.form[key].map((item, index) => {
                for (const field in item) {
                  if (field == 'day') {
                    data.append(`${key}[${index}][${field}]`, item[field])
                  } else {
                    data.append(
                      `${key}[${index}][${field}]`,
                      moment(item[field], 'hh:mm A') // Use 'hh:mm A' for 12-hour format
                        .set({ year: 1970, month: 0, date: 1 })
                        .utcOffset(moment().utcOffset())
                        .utc()
                        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                    )
                  }
                }
              })
            } else if (key === 'social_media') {
              for (const platform in this.form.social_media) {
                if (this.form.social_media[platform]) {
                  data.append(`social_media[${platform}]`, this.form.social_media[platform])
                }
              }
            } else if (key === 'custom_link') {
              // Handle custom_link as a separate case
              this.form.custom_link.forEach((item, index) => {
                data.append(`custom_link[${index}][title]`, item.title || '')
                data.append(`custom_link[${index}][link]`, item.link || '')
              })
              continue // Skip the default handling for custom_link
            } else {
              if (this.form[key]) {
                this.form[key].map((item) => {
                  data.append(key == 'gurudwara_image' || key == 'gurudwara_video' ? key : key + '[]', item)
                })
              }
            }
          } else {
            data.append(key, this.form[key])
          }
        }

        if (this.form.longitude && this.form.latitude) {
          // Add location manually
          data.append('location', JSON.stringify({
            type: 'Point',
            coordinates: [parseFloat(this.form.longitude), parseFloat(this.form.latitude)]
          }))
        }


        if (this.$route.params.id) {
          response = await this.update({
            id: this.$route.params.id,
            data
          })
          this.activeTab = 1
        } else {
          response = await this.create(data)
          this.$router.push(`/gurudwara/${response.data._id}/edit`)
        }

        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },
    async save_sarai_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const sarai_data = { ...this.sarai_form }
        sarai_data.gurudwara = this.$route.params.id
        sarai_data.offer_sarai_stay = !this.sarai_form.offer_sarai_stay

        const response = await this.updateSarai({
          data: sarai_data
        })

        this.activeTab = 2
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    async fetchStates() {
      if (!this.form.country) return
      const stateResult = await this.getStates({
        country: this.form.country,
        page: 1,
        limit: 300000,
        type: 'dropdown'
      })
      this.StateList = stateResult.data
    },
    async fetchCities() {
      if (!this.form.state) return
      const cityResult = await this.getCities({
        state: this.form.state,
        country: this.form.country,
        page: 1,
        limit: 300000,
        type: 'dropdown'
      })
      this.CityList = cityResult.data
    },

    /** add data in array */
    addData(type) {
      switch (type) {
      case 'other_name':
        this.form.other_name.push('')
        break
      case 'sarai':
        this.sarai_form.details.push({
          name: '',
          email: '',
          website: '',
          location: '',
          mobile_number: [],
          custom_fields: [] // Add this line
        })
        break
      case 'youtube_handle_name':
        this.form.youtube_handle_name.push('')
        break
      default:
        break
      }
    },

    /** remove data from array */
    removeData(type, index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          switch (type) {
          case 'other_name':
            this.form.other_name.splice(index, 1)
            break
          case 'sarai':
            this.sarai_form.details.splice(index, 1)
            break
          case 'youtube_handle_name':
            this.form.youtube_handle_name.splice(index, 1)
            break
          default:
            break
          }
        },
        acceptText: 'Delete'
      })
    },

    /** add mobile number for sarai */
    addMobileNumber(saraiIndex) {
      this.sarai_form.details[saraiIndex].mobile_number.push('')
    },

    /** remove mobile number for sarai */
    removeMobileNumber(saraiIndex, mobileIndex) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          this.sarai_form.details[saraiIndex].mobile_number.splice(mobileIndex, 1)
        },
        acceptText: 'Delete'
      })
    },

    /** navigate to gurudwaraList */
    navigateToGurudwaraList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'gurudwara-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },

    /** file upload  */
    handleFileUpload(e) {
      const files = Array.from(e.target.files) // Convert FileList to array

      // Check the total number of images, including existing ones
      const totalImages = files.length + this.preview_images.length + this.form.exist_gurudwara_image.length
      if (totalImages > GURUDWARA_MAX_IMAGES_COUNT) {
        this.$vs.notify({
          title: 'Error',
          text: `You can upload a maximum of ${GURUDWARA_MAX_IMAGES_COUNT} images. Current selection exceeds the limit.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        // e.target.value = '' // Reset input value to allow re-selection
        return
      }

      this.crop_image = [] // user don't crop image and upload cancel to cropper Empty
      // Validate and handle each file
      files.forEach((file) => {
        if (!file) {
          this.$vs.notify({
            title: 'Error',
            text: 'No file selected',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          // e.target.value = '' // Reset input value to allow re-selection
          return
        }

        if (file.size > MAX_IMAGE_SIZE) {
          // Validate file size (1 MB)
          this.$vs.notify({
            title: 'Error',
            text: `File "${file.name}" exceeds the ${MAX_IMAGE_SIZE / 1024 / 1024}MB size limit.`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          // e.target.value = '' // Reset input value to allow re-selection
          return
        }

        // Create a preview URL and add it to the array
        // const previewURL = URL.createObjectURL(file);
        // this.preview_images.push({ src: previewURL, file });
        // this.form.gurudwara_image.push(file);

        // Create a blob for cropping
        const blob = URL.createObjectURL(file)

        this.crop_image.push({
          src: blob,
          type: file.type
        })

        // Open cropper popup
        this.IsOpenImageCrop = true

        // Increment fileKey to force re-render
        this.fileKey++
      })
      // e.target.value = '' // Reset input value to allow re-selection
    },
    cropImage() {
      this.$refs.cropper.forEach((element, key) => {
        const result = element.getResult()
        if (!result.canvas) {
          this.$vs.notify({
            title: 'Error',
            text: 'Please crop the image before uploading.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          return
        }

        // Convert cropped image to base64 and validate size
        const resultBase64 = result.canvas.toDataURL(this.crop_image[key].type)
        const base64Image = resultBase64.replace(`data:${this.crop_image[key].type};base64,`, '')
        const blob = this.b64toBlob(base64Image, this.crop_image[key].type, key)

        // Ensure cropped image size is less than 1 MB
        if (blob.size > MAX_IMAGE_SIZE) {
          this.$vs.notify({
            title: 'Error',
            text: `Cropped image exceeds the ${MAX_IMAGE_SIZE / 1024 / 1024}MB size limit.`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
          return
        }

        this.preview_images.push({ src: URL.createObjectURL(blob), blob })
        this.form.gurudwara_image.push(blob)
      })

      this.crop_image = []
      this.IsOpenImageCrop = false
    },

    b64toBlob(b64Data, contentType = '', key, sliceSize = 512) {
      const byteCharacters = window.atob(b64Data)
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new File(byteArrays, `image_${key}.jpg`, {
        type: contentType
      })
      // this.form.image = blob;
      // this.preview_image = URL.createObjectURL(blob);

      // this.form.gurudwara_image.push(file);

      // this.preview_images.push({ src: URL.createObjectURL(blob), blob })
      // this.form.gurudwara_image.push(blob)

      return blob
    },

    /** remove file */
    removeFile(index, type) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this image?`,
        accept: () => {
          if (type === 'preview') {
            // Revoke the object URL
            URL.revokeObjectURL(this.preview_images[index].src)

            // Remove the file from the arrays
            this.preview_images.splice(index, 1)
            this.form.gurudwara_image.splice(index, 1)
          } else {
            const exist_index = this.form.exist_gurudwara_image.findIndex((value) => index === value)
            if (exist_index !== -1) {
              this.form.exist_gurudwara_image.splice(exist_index, 1)
            }
          }
        },
        acceptText: 'Delete'
      })
    },
    async handleVideoUpload(e) {
      const files = Array.from(e.target.files)
      const totalVideos = files.length + this.preview_videos.length + this.form.exist_gurudwara_video.length

      if (totalVideos > GURUDWARA_MAX_VIDEOS_COUNT) {
        this.$vs.notify({
          title: 'Error',
          text: `You can upload a maximum of ${GURUDWARA_MAX_VIDEOS_COUNT} videos.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      for (const file of files) {
        if (!file) continue

        try {
          const duration = await this.getVideoDuration(file)
          if (duration > MAX_VIDEO_DURATION) {
            this.$vs.notify({
              title: 'Error',
              text: `Video "${file.name}" exceeds the ${MAX_VIDEO_DURATION} seconds limit.`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              position: 'top-center',
              time: 5000,
              color: 'primary'
            })
            continue
          }

          const previewURL = URL.createObjectURL(file)
          this.preview_videos.push({ src: previewURL, file })
          this.form.gurudwara_video.push(file)
        } catch (error) {
          this.$vs.notify({
            title: 'Error',
            text: `Failed to process video "${file.name}".`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        }
      }
      this.fileKey++
    },
    getVideoDuration(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.preload = 'metadata'
        video.onloadedmetadata = () => {
          window.URL.revokeObjectURL(video.src)
          resolve(video.duration)
        }
        video.onerror = () => {
          reject('Error loading video')
        }
        video.src = URL.createObjectURL(file)
      })
    },
    removeVideo(index, type) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this video?`,
        accept: () => {
          if (type === 'preview') {
            URL.revokeObjectURL(this.preview_videos[index].src)
            this.preview_videos.splice(index, 1)
            this.form.gurudwara_video.splice(index, 1)
          } else {
            const exist_index = this.form.exist_gurudwara_video.findIndex((value) => index === value)
            if (exist_index !== -1) {
              this.form.exist_gurudwara_video.splice(exist_index, 1)
            }
          }
        },
        acceptText: 'Delete'
      })
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-gurudwara',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-gurudwara > .con-vs-loading')
      }
    },
    'form.country'(newValue) {
      this.form.state = null
      this.form.city = null
      this.StateList = []
      this.CityList = []
      if (newValue) {
        this.fetchStates()
      }
    },
    'form.state'(newValue) {
      this.form.city = null
      this.CityList = []
      if (newValue) {
        this.fetchCities()
      }
    },

    // countryID(newValue) {
    //   this.StateList = []
    //   this.form.state = null
    //   this.stateID = null
    //   if (newValue && newValue.value) {
    //     this.fetchStates()
    //   }
    // },
    // stateID(newValue, oldValue) {
    //   this.CityList = []
    //   this.form.city = null
    //   this.cityID = null
    //   if (newValue && newValue.value) {
    //     this.fetchCities()
    //   }
    // },
    async '$route.params.id' (newId) {
      await this.fetchData()
      if (this.$route.query.tab === 'sarai') {
        this.activeTab = 2
      } else {
        this.activeTab = 1
      }
    },
    '$route.query.tab' (newTab) {
      if (newTab === 'sarai') {
        this.activeTab = 2
      }
    }
  }
}
</script>

<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}

.color {
  background-image: none !important;
}

.con-slot-tabs {
  overflow-y: auto !important;
  margin-top: 10px;
  height: -webkit-fill-available;
}

/* Instant tab switches — no left/right slide animation */
.gurudwara-tabs-instant >>> .fade-tab-enter-active,
.gurudwara-tabs-instant >>> .fade-tab-leave-active,
.gurudwara-tabs-instant >>> .fade-tab-invert-enter-active,
.gurudwara-tabs-instant >>> .fade-tab-invert-leave-active,
.gurudwara-tabs-instant >>> .fade-tab-vertical-enter-active,
.gurudwara-tabs-instant >>> .fade-tab-vertical-leave-active,
.gurudwara-tabs-instant >>> .fade-tab-vertical-invert-enter-active,
.gurudwara-tabs-instant >>> .fade-tab-vertical-invert-leave-active {
  transition: none !important;
}

.gurudwara-tabs-instant >>> .fade-tab-enter,
.gurudwara-tabs-instant >>> .fade-tab-leave-to,
.gurudwara-tabs-instant >>> .fade-tab-invert-enter,
.gurudwara-tabs-instant >>> .fade-tab-invert-leave-to,
.gurudwara-tabs-instant >>> .fade-tab-vertical-enter,
.gurudwara-tabs-instant >>> .fade-tab-vertical-leave-to,
.gurudwara-tabs-instant >>> .fade-tab-vertical-invert-enter,
.gurudwara-tabs-instant >>> .fade-tab-vertical-invert-leave-to {
  opacity: 1 !important;
  transform: none !important;
  position: relative !important;
}

.custom-field-entry {
  /* background-color: #ffffff; */
  padding: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.line-vs-tabs {
  height: 4px !important;
}

.gurudwara-tabs-instant .vs-tabs--ul.ul-tabs-fixed {
  height: auto !important;
  min-height: 40px;
  overflow: visible !important;
  flex-wrap: wrap !important;
  justify-content: flex-start !important;
}

.gurudwara-tabs-instant .vs-tabs--ul.ul-tabs-fixed li {
  width: auto !important;
  flex: 0 0 auto !important;
}

.con-vs-card,
.vs-card--content {
  margin-bottom: 0px;
}

.vti__input {
  background: var(--page-bg);
}
</style>
